/* eslint-disable no-unused-vars */
/* eslint-disable no-console */
/* eslint-disable no-alert */
/* eslint-disable no-plusplus */
/* eslint-disable no-param-reassign */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-unexpected-multiline */

/* eslint-disable func-names */
/* eslint-disable prefer-arrow-callback */
/* eslint-disable object-shorthand */
/* eslint-disable no-shadow */
/* eslint-disable dot-notation */

export default {
  install(Vue) {
    const crypto = window.crypto.subtle;

    /*
    function ab2str(buf) {
      return String.fromCharCode.apply(null, new Uint16Array(buf));
    }
    function str2ab(str) {
      const buf = new ArrayBuffer(str.length * 2); // 2 bytes for each char
      const bufView = new Uint16Array(buf);
      for (let i = 0, strLen = str.length; i < strLen; i++) {
        bufView[i] = str.charCodeAt(i);
      }
      return buf;
    }
    */

    function ab2str(buf) {
      return String.fromCharCode.apply(null, new Uint8Array(buf));
    }

    function str2ab(str) {
      const buf = new ArrayBuffer(str.length); // 1 bytes for each char
      const bufView = new Uint8Array(buf);
      for (let i = 0, strLen = str.length; i < strLen; i++) {
        bufView[i] = str.charCodeAt(i);
      }
      return buf;
    }

    function arrayBufferToUtf8(arrayBuffer) {
      return new TextDecoder('utf-8').decode(arrayBuffer);
    }

    function str2abUtf8(myString) {
      return new TextEncoder('utf-8').encode(myString);
    }

    function base64StringToArrayBuffer(base64) {
      const binaryString = atob(base64);
      const len = binaryString.length;
      const bytes = new Uint8Array(len);
      for (let i = 0; i < len; i++) {
        bytes[i] = binaryString.charCodeAt(i);
      }
      return bytes.buffer;
    }

    function arrayBufferToBase64String(arrayBuffer) {
      const byteArray = new Uint8Array(arrayBuffer);
      let byteString = '';
      for (let i = 0; i < byteArray.byteLength; i++) {
        byteString += String.fromCharCode(byteArray[i]);
      }
      return btoa(byteString);
    }

    //
    //
    //
    //
    // wrapper for importing AES key for using with crypto library
    function importPublicKeyCBC(key) {
      return new Promise(function (resolve, rej) {
        crypto.importKey('raw', str2abUtf8(key),
          {
            name: 'AES-CBC',
          },
          false, // whether the key is extractable (i.e. can be used in exportKey)
          ['encrypt', 'decrypt'], // can be "encrypt", "decrypt", "wrapKey", or "unwrapKey"
        ).then(function (cryptKey) {
          resolve(cryptKey);
        });
      });
    }

    // wrapper for importing AES key for using with crypto library
    function importPublicKeyGCM(key) {
      return new Promise(function (resolve, rej) {
        crypto.importKey('raw', str2abUtf8(key),
          {
            name: 'AES-GCM',
          },
          false, // whether the key is extractable (i.e. can be used in exportKey)
          ['encrypt', 'decrypt'], // can be "encrypt", "decrypt", "wrapKey", or "unwrapKey"
        ).then(function (cryptKey) {
          resolve(cryptKey);
        });
      });
    }

    // separate initialization vector from message
    function separateVectorFromData(data) {
      const iv = data.slice(-24);
      const message = data.substring(0, data.length - 24);

      return {
        iv: iv,
        message: message,
      };
    }

    // add initialization vector to message
    function getMessageWithIv(message, iv) {
      return arrayBufferToBase64String(message) + arrayBufferToBase64String(iv);
    }

    Vue.prototype.$encryptCBC = function encryptCBC(key, iv, message) {
      return new Promise(function (resolve, rej) {
        importPublicKeyCBC(key).then(function (key) {
          crypto.encrypt(
            {
              name: 'AES-CBC',
              // Don't re-use initialization vectors!
              // Always generate a new iv every time your encrypt!
              iv: str2abUtf8(iv),
            },
            key, // from generateKey or importKey above
            str2abUtf8(message), // ArrayBuffer of data you want to encrypt
          )
            .then(function (encrypted) {
              encrypted = arrayBufferToBase64String(encrypted);
              resolve(encrypted);
            });
        });
      });
    };

    Vue.prototype.$decryptCBC = function decryptCBC(key, iv, message) {
      return new Promise(function (resolve, rej) {
        importPublicKeyCBC(key).then(function (key) {
          crypto.decrypt(
            {
              name: 'AES-CBC',
              iv: str2abUtf8(iv),
            },
            key, // from generateKey or importKey above
            base64StringToArrayBuffer(message), // ArrayBuffer of data you want to encrypt
          )
            .then(function (decrypted) {
              resolve(arrayBufferToUtf8(decrypted));
            });
        });
      });
    };

    Vue.prototype.$encryptGCM = function encryptGCM(key, iv, message) {
      return new Promise(function (resolve, rej) {
        importPublicKeyGCM(key).then(function (key) {
          crypto.encrypt(
            {
              name: 'AES-GCM',
              // Don't re-use initialization vectors!
              // Always generate a new iv every time your encrypt!
              iv: str2abUtf8(iv),
            },
            key, // from generateKey or importKey above
            str2abUtf8(message), // ArrayBuffer of data you want to encrypt
          )
            .then(function (encrypted) {
              encrypted = arrayBufferToBase64String(encrypted);
              resolve(encrypted);
            });
        });
      });
    };

    Vue.prototype.$decryptGCM = function decryptGCM(key, iv, message) {
      return new Promise(function (resolve, rej) {
        importPublicKeyGCM(key).then(function (key) {
          crypto.decrypt(
            {
              name: 'AES-GCM',
              iv: str2abUtf8(iv),
            },
            key, // from generateKey or importKey above
            base64StringToArrayBuffer(message), // ArrayBuffer of data you want to encrypt
          )
            .then(function (decrypted) {
              resolve(arrayBufferToUtf8(decrypted));
            });
        });
      });
    };

    //
    //
    //
    //
    //
    // dec2hex :: Integer -> String
    // i.e. 0-255 -> '00'-'ff'
    function dec2hex(dec) {
      return (`0${dec.toString(16)}`).substr(-2);
    }

    // generateId :: Integer -> String
    function generateId(len) {
      const arr = new Uint8Array((len || 40) / 2);
      window.crypto.getRandomValues(arr);
      return Array.from(arr, dec2hex).join('');
    }

    Vue.prototype.$generateAESKeyAndIV = function $generateAESKeyAndIV(keyLen, ivLen) {
      // for AES GCM, keylen=32, ivLen=12
      const key = generateId(keyLen);
      const iv = generateId(ivLen);
      // console.log('key[', key, '] iv[', iv, ']');
      return {
        key: key,
        iv: iv,
      };
    };
  },
};



// WEBPACK FOOTER //
// ./src/js/AesWrapper.js